import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import "./BookList.css";
import coverImg from "../../images/cover_not_found.jpg";

const Journal = (book) => {
  const [showButtons, setShowButtons] = useState(false);
  //searchCriteria.category
//   console.log("book fsddf fsddf " );
// console.log(book);
  let linktoDeta = "";

  if(book.type == "book"){
    linktoDeta = `/book/${book.id}`;
  }else{

    linktoDeta = `/journal/${book.category_id}`;

  }
  const handleMouseEnter = () => {
    setShowButtons(true);
  };

  const handleMouseLeave = () => {
    setShowButtons(false);
  };

  const handleCoverClick = () => {
    if (!showButtons) {
      setShowButtons(true);
    }
  };
  const handleOpenLink = (url,id) => {
    // Check if the URL is valid and not "لايوجد رابط"
    if (url && url !== "لايوجد رابط" && /^(http:\/\/|https:\/\/)/.test(url)) {
      // Open the URL in a new tab
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      //console.log("Invalid URL or No URL Provided");
    }
  };
  function isImageUrl(url) {
    try {
      // Check if the URL is a string
      if (typeof url !== 'string') {
return      }
      // The regular expression checks for image file extensions at the end of the string
      // Extensions included: .jpg, .jpeg, .png, .gif (case-insensitive)
      return /\.(jpg|jpeg|png|gif)$/i.test(url);
    } catch (error) {
      console.error(error.message);
      // Return false on error, could be logged or handled as needed
      return false;
    }
  }
return (

    <div className='book-item flex flex-column flex-sb' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} >
      <div className='book-item-img' onClick={handleCoverClick}>
      <img src={isImageUrl(book.image_url)? book.image_url : coverImg } loading='lazy' alt="" />
        {showButtons && (
          <div className="cover-buttons">
            <Link to={linktoDeta} className="book-details-btn">تفاصيل </Link>

          </div>
        )}
      </div>
      <div className='book-item-info text-center'>
        <div className='book-item-info-item title fw-7 fs-18'>
          <Link style={{color:"black"}} to={linktoDeta}>{book.category_name}</Link>
                
        </div>
        
       
   
       
      
      </div>
    </div>

  )
}

export default Journal;